import React, {useRef, useEffect, useState} from 'react'

import {
    GoogleMap,
    useJsApiLoader,
    Marker,
    Polyline,
    Polygon,
} from "@react-google-maps/api";

/*eslint-disable */


const containerStyle = {
    width: "100%",
    height: "100%",
};

interface DynamicMapProps {
    locationData: any,
    filteredRoute: string,
    selectedPOI: any,
    colorsData: any,
    routesActive: boolean,
    POISActive: boolean,
    isLocation: boolean
}

const DynamicMap = ({locationData, filteredRoute, selectedPOI, colorsData, routesActive, POISActive, isLocation}: DynamicMapProps) => {

    const ref: any = useRef();
    const [map, setMap] = React.useState(null);
    const [POIsToShow, setPOIsToShow]: any = useState([])
    const [center, setCenter] = useState({
      lat: parseFloat(locationData.center.lat),
      lng: parseFloat(locationData.center.lng)
    })
    const [currentZoom, setZoom] = useState(parseFloat(locationData.defaultZoom))

    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: "AIzaSyBFIueHL6ufyFll26ee6TfN-qVpSvtp0sw",
    });

    const onLoad = React.useCallback(function callback(map: any) {
        const bounds = new window.google.maps.LatLngBounds({
          lat: parseFloat(locationData.center.lat),
          lng: parseFloat(locationData.center.lng)
        });
        map.fitBounds(bounds);
        setMap(map);
    }, []);
    
    const onUnmount = React.useCallback(function callback(map: any) {
        setMap(null);
    }, []);

    const OPTIONS = {
        zoom: currentZoom,
        minZoom: 10,
        maxZoom: locationData.maxZoom,
        disableDoubleClickZoom: true,
        draggableCursor: "pointer",
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: false,
        scrollwheel: locationData.zoom_state === 1 ,
        mapTypeControl: false,
        styles: [
          {
            "featureType": "administrative",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#878787"
              }
            ]
          }
        ]
    };


    useEffect(() => {
        handleCreateRoute()
        if(!isNaN(locationData.center.lat)){
          setCenter({
            lat: parseFloat(locationData.center.lat),
            lng: parseFloat(locationData.center.lng)
          })
          setZoom(parseInt(locationData.defaultZoom))
        }
    }, [filteredRoute])


    const handleCreateRoute = () => {
        let routesArray: any = []
        for(let i = 0; i < locationData.routes.length; i++){
            if(filteredRoute !== locationData.routes[i].name && filteredRoute !== ""){
                continue
            }
            routesArray.push(
                <Polyline
                    key={locationData.routes[i].name + i}
                    path={locationData.routes[i].trace}
                    options={{
                        strokeColor: locationData.routes[i].color,
                        strokeOpacity: 0.75,
                        strokeWeight: 10
                    }}
                />
            )
        }

        return routesArray
    }

    const createPOICanvas = (poi: any, index: number) => {

      const canvas = document.createElement('canvas');
      const context = canvas.getContext("2d");
      const text = poi.name;

      if(context){
        // Set font properties
        const fontSize = 16;
        const fontFamily = "Montserrat Regular";
        context.font = `${fontSize}px ${fontFamily}`;

        // Calculate text width
        const textWidth = context.measureText(text).width;

        // Set canvas width
        canvas.width = textWidth + 20;
        canvas.height = 35
        canvas.id = 'canvas-map'

        context.fillStyle = '#fff';
        context.fillRect(0, 0, canvas.width, canvas.height);

        // Draw text on the canvas
        context.fillStyle = colorsData.main_buttons;
        context.font = !(navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) ? '0.75rem Montserrat Regular':'1rem Montserrat Regular'
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillText(text, (canvas.width/2), (canvas.height / 2));
      }

      var url = canvas.toDataURL()

      const anchorPoint = new window.google.maps.Point(canvas.width/2, 55 + (index % 2 === 0 ? 50 : 150 ))

      return(
        <Marker
        position={
          {
            lat: parseFloat(poi.center.lat),
            lng: parseFloat(poi.center.lng)
          }
        }
        icon={{
            url: url,
            fillColor: "#EB00FF",
            anchor: anchorPoint
        }}
        zIndex={200}
        />
      )
    }

    useEffect(() => {
      if(selectedPOI.PoisArray){
        var sortedPOISArray = [...selectedPOI.PoisArray]
        sortedPOISArray.sort((a: any, b: any) => {
          if (a.center.lng < b.center.lng) {
            return -1;
          }
          if (a.center.lng > b.center.lng) {
            return 1;
          }
          return 0;
        })

        setPOIsToShow(sortedPOISArray.reverse())
      }

      if(selectedPOI.latitud){
        setCenter({
          lat: parseFloat(selectedPOI.latitud),
          lng: parseFloat(selectedPOI.longitud)
        })
        setZoom(parseFloat(selectedPOI.zoom))
      }
    }, [selectedPOI])


    const handleCreateLine = (index: number, poi: any) => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext("2d");

      if(context){

        // Set canvas width
        canvas.width = 6;
        canvas.height = (index % 2 === 0 ? 50 : 150 )
        canvas.id = 'canvas-map'

        context.fillStyle = colorsData.main_buttons;
        context.fillRect(canvas.width / 2, 0, canvas.width / 2, canvas.height);
        context.fillStyle = colorsData.secondary_text;
      }

      var url = canvas.toDataURL()


      const anchorPoint = new window.google.maps.Point(3, 55 + (index % 2 === 0 ? 50 : 150 ))

      return(
        <Marker
        position={
          {
            lat: parseFloat(poi.center.lat),
            lng: parseFloat(poi.center.lng)
          }
        }
        icon={{
            url: url,
            fillColor: "#EB00FF",
            anchor: anchorPoint
        }}
        zIndex={100}
        />
      )
    }

    return(
        <div className='dynamic-map-container'>
            {
                isLoaded ?(
                    <GoogleMap
                        options={OPTIONS}
                        ref={ref}
                        mapContainerStyle={containerStyle}
                        center={center}
                        onLoad={onLoad}
                        onUnmount={onUnmount}
                    >
                        <React.Fragment>
                            <Marker
                                position={
                                    {
                                      lat: parseFloat(locationData.logo_proyecto.center.lat),
                                      lng: parseFloat(locationData.logo_proyecto.center.lng)
                                    }
                                }
                                icon={{
                                    url: "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"+locationData.logo_proyecto.icon,
                                    scaledSize: new window.google.maps.Size(80, 80),
                                    anchor: new google.maps.Point(80 / 2, 80/2),
                                    fillColor: "#EB00FF",
                                }}
                            />
                            {routesActive && isLocation ? 
                                handleCreateRoute():null
                            }
                            {
                                POIsToShow.length > 0 && POISActive && isLocation ? 
                                POIsToShow.map((poi: any, index: number) => 
                                <React.Fragment>
                                  {
                                    handleCreateLine(index,poi)
                                  }
                                  {
                                    createPOICanvas(poi, index)
                                  }
                                </React.Fragment>
                                ):null
                            }
                            <Polygon
                              path={locationData.coordenates_delimitations}
                              options = {{
                                fillColor: locationData.color_delimitation,
                                strokeColor: locationData.color_delimitation
                              }}
                            />
                            {
                              
                            }
                        </React.Fragment>
                    </GoogleMap>
                ) : (
                    <></>
                )
            }
        </div>
    )
}

export default DynamicMap